// @flow

import _ from 'lodash';
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';

import get_order from './orden.js';
import {ROOT_DIR} from './consts.js';

import App from './App.jsx';

import {LB_PM, DOMAIN} from './consts.js';

import type {T_Node, T_Item, T_Ext, T_Next, T_Pred, T_PredOf, T_NumTransformer} from './types.js';
import type {T_Stats} from './Stats.jsx'
import type {T_DbfRow} from './Shp.js';

const S = require('underscore.string');

require('numeral/locales/es');

const numeral = require('numeral');

numeral.locale('es');

_.templateSettings.interpolate = /{{([\s\S]+?)}}/g;



// fixslash reemplaza slashes dobles por un slash simple.

export function fixslash(path: string): string {
  return path.replace(/\/\//g, '/');
}



export function takeDir(path: string): string {   // devuelve el directorio de un path, SIN INCLUIR EL SLASH FINAL.
  if (! path) {
    return '';
  }
  
  return path.substring(0, path.lastIndexOf('/'));
}



export function takeFilename(path: string): string {
  return path.replace(/^.*[/]/, '');  // para detectar problemas.
}



export function strip_end_slash(path: string): string {
  return path[path.length - 1] === '/' ? path.slice(0, path.length - 1) : path;
}



export function add_end_slash(path: string): string {
  return path[path.length - 1] === '/' ? path : `${path}/`;
}



export function mk_title(str: string): string {
  return S.titleize(str.replace(/_/g, ' '))
          .replace(/ Y /g, ' y '  )
          .replace(/ De /g, ' de ')
          .replace('Mav', 'MAV'   )
          .replace('Utm', 'UTM'   )
          .replace('M.o', 'M.O'   )
          .replace('Cnc', 'CNC'   )     // NOTE: siglas que deben permanecer en mayúsculas.
          .replace('Cnpr', 'CNPR' );
}



export function takeBasename(fname: string): string {
  const last_dot = fname.lastIndexOf('.');
  
  if (last_dot !== -1) {
    return fname.slice(0, last_dot);
  }
  
  return fname;
}



// Devuelve la última extensión del archivo. A diferencia de Haskell, esta función excluye el punto.
// Si el nombre no incluye el punto, devuelve el string original.

export function takeExtension(path: string): T_Ext {
  const re = path.substr(path.lastIndexOf('.') + 1);
  
  if (re === 'shp' || re === 'png' || re === 'obs' || re === 'sensor') {
    return re;
  }
  
  return 'dir';
}



export function pad(num: number): string {
  if (num < 10) {
    return `0${num}`;
  }
  else {
    return `${num}`;
  }
}



export function dec_pad(num: number): string {
  const ns: string = `${num}`,
      idx = ns.indexOf('.');
  
  if (idx === -1) {
    return `${ns}.00`;
  }
  
  if (ns.length - ns.indexOf('.') === 2) {
    return `${ns}0`;
  }
  
  return ns;
}



export const meses: Array<string> = [
  'Ene',         //  1
  'Feb',         //  2
  'Mar',         //  3
  'Abr',         //  4
  'May',         //  5
  'Jun',         //  6
  'Jul',         //  7
  'Ago',         //  8
  'Sep',         //  9
  'Oct',         // 10
  'Nov',         // 11
  'Dic'          // 12
];



export function fecha() {
  const now = new Date();
  
  return `${meses[now.getMonth()]}${pad(now.getDate())}_${now.getFullYear()}`;
}



export function round1(num: number): number {
  return (Math.round(num * 10) / 10);
}



export function round2(num: number): number {
  return (Math.round(num * 100) / 100);
}



export function round4(num: number): number {
  return (Math.round(num * 10000) / 10000);
}



export function round6(num: number): number {
  return (Math.round(num * 1000000) / 1000000);
}



export function snum(num: number, num_decimals: number): string {
  numeral.locale('es');
  const fmt = `0,0.${_.repeat('0', num_decimals)}`;
  
  return numeral(num).format(fmt);
}



export function sep_mil(num: any): string {
  numeral.locale('es');
  if (num === '-')
    return '-';
  
  return numeral(num).format('0,0');
}



export function gen_snum(num_decimals: number): (number) => string {
  numeral.locale('es');
  const fmt = `0,0.${_.repeat('0', num_decimals)}`;
  
  return (num: number): string => {
    return numeral(num).format(fmt);
  };
}



export function dec6(num: number): string {
  const ns = `${num}`;
  
  return ns + _.repeat('0', 7 - (ns.length - ns.indexOf('.')));
}



export function inv_ord(ord: string): string {
  return ord === 'sort-desc' ? 'sort-asc' : 'sort-desc';
}



export function isNumber(num: ?string): boolean {
  return !isNaN(parseFloat(num)) && isFinite(num);
}



export function abrev(str: string, len_max: number = 12): string {
  return str.length > len_max ? `${str.slice(0, len_max)}…` : str;
}



export function title_culti(path: string): string {
  const filename = takeFilename(path),
        lowfile  = filename.toLowerCase();
  
  let tp = '';
  
  if (filename.indexOf('mav_') === 0) {
    return `Mav ${S.titleize(path.split('/')[5].split('_').join(' '))} ${labelize_mav(filename).slice(4)}`;
  }
  else if (lowfile.indexOf('pm_') === 0 || lowfile === 'pm.shp' || filename.indexOf('ms_0000') === 0) {
    return LB_PM;
  }
  else if (filename.indexOf('cultivable_') === 0) {
    tp = 'Cultivable ';
  }
  else if (filename.charAt(0) === 'm') {
    tp = `Muestras ${tipo_muestra(path)} `;
  }
  else if (filename.indexOf('Sensor-') === 0) {
    tp = '';
  }
  
  return `${tp}${S.titleize(takeBasename(filename).slice(11).split('_').join(' '))}`;
}





export function sub_paths(path: string): Array<string> {
  let last = ROOT_DIR;
  
  return path.split('/').slice(2).map((xd) => {
    last = `${last}/${xd}`;
    return last;
  });
}



// Determina si path está dentro de dir o viceversa.
// Por ejemplo, el path /a/b/c/hola.shp está dentro de /a/b/

export function path_is_inside_bi(path: string, dir: string): boolean {
  const ds1 = _.compact(path.split('/')),
        ds2 = _.compact( dir.split('/')),
        min = Math.min(ds1.length, ds2.length);
  
  return _.isEqual(_.take(ds1, min),
                   _.take(ds2, min));
}



// Determina el el primer path está dentro del segundo.

export function path_is_inside(path: string, dir: string): boolean {
  return path.length > dir.length && path_is_inside_bi(path, dir);
}



export function toRef(path: string): string {
  return path.slice(6).replace(/[^0-9A-Z]+/gi, '_');
}



//    |----------|---------------------------------------|       Si b - a representa 1, cuánto sería c - a?
//    a          c                                       b

export function proporcion(na: number, nb: number, nc: number): number {
  return (nc - na) / (nb - na);
};



export function format_distance(mt: number): string {
  return mt < 1000 ? `${Math.round(mt)} m` : `${round1(mt / 1000)} km`;
}



function readTableDosis(element) {
  const ar   = [],
        rows = element.querySelectorAll('tr');
  
  for (let ii = 0; ii < rows.length; ii++) {
    const row   = rows[ii],
          aa    = [],
          cells = row.querySelectorAll('th,td');
    
    for (let jj = 0; jj < cells.length; jj++) {
      const cell = cells[jj],
            span = cell.querySelectorAll('span');
      
      if (span.length > 0) {
        aa.push(span[0].style.background);
      }
      else {
        aa.push(cell.innerText);
      }
    }
    
    ar.push(aa);
  }
  
  return ar;
}




export type T_ReadMavRow = {
  desde: number,
  hasta: number,
  dosis: number,
  area : number,
  total: number,
  color: string
};


export function mav_rows(html_body: string, dbfRecords: Array<T_DbfRow>): Array<T_ReadMavRow> {
  const tb = document.createElement('table');
  
  tb.innerHTML = html_body;
  
  return _.map(_.tail(readTableDosis(tb)), (xs) => {
    const dosis   = parseFloat(xs[2]),
          f_dosis = rec => rec.DOSIS === dosis,
          area    = _.sum(_.map(_.filter(dbfRecords, f_dosis), 'AREA')) / 10000,
          xd       = _.find(dbfRecords, f_dosis);
    
    return {
      desde: parseFloat(xs[0]),
      hasta: parseFloat(xs[1]),
      dosis,
      area,
      total: Math.round(dosis * area),
      color: `#${xd ? xd.COLOR : 'bbbbbb'}`
    };
  });
}



export function is_year(str: string): boolean {       // NOTA: USA is_date, que sirve para las dos
  const isNum = isNumber(str),                        // estructuras de directorios, la antigua y la nueva.
        yy    = isNum ? parseInt(str, 10) : 0;        // is_year se considera obsoleta y no debe
  return isNum && 1950 < yy && yy < 2100;             // ser usada para código nuevo.
}



export function is_date(str: string): boolean {
  if (! str)
    return false;
  
  if (is_year(str))
    return true;
  
  const xs = str.split('-');
  
  return xs.length === 3 && is_year(xs[0]) && _.every(xs, isNumber) && xs[1].length === 2 && xs[2].length === 2;
}



export const ms_regex    = /^ms_|^mfs_|^mf_|^mr_|^mt_/;
export const culti_regex = /^cultivable_/;



export function getFechaMs(ms_path: string): string {
  const fname = takeFilename(ms_path);
  
  if (_.startsWith(fname, 'union_ms_'))
    return '-';
  
  const fechaMs = fname.split('_')[1],
        msDay   = fechaMs.substr(0, 2),
        msMonth = fechaMs.substr(2, 2),
        msYear  = fechaMs.substr(4, 4);
  
  return `${msDay}/${msMonth}/${msYear}`;
}



function checkImage(imageSrc: string, good: T_Next, bad: T_Next) {
    const img = new Image();
    
    img.onload = good; 
    img.onerror = bad;
    img.src = imageSrc;
}



export function imageExists(image_url: string, next: T_Next) {
  checkImage(image_url, () => next(true), () => next(false));
}



export function tipo_muestra(ms_path: string): string {
  const file = takeFilename(ms_path);
  
  if (_.startsWith(file, 'ms_' )) { return 'de Suelo';       }
  if (_.startsWith(file, 'mr_' )) { return 'de Rendimiento'; }
  if (_.startsWith(file, 'mfs_')) { return 'Físicas';        }
  if (_.startsWith(file, 'mf_' )) { return 'Foliares';       }
  if (_.startsWith(file, 'mt_' )) { return '';               }   // Qué son las mt???
  return '';
}



export const img_html = _.template("<img src='{{url}}' />");



export function splitarray<T>(xs: Array<T>, num: number): Array<Array<T>> {  // parte xs en varios padazos de n elementos
  const rs = [];
  
  for (let ii = 0; ii < xs.length; ii += num) {
    rs.push(xs.slice(ii, ii + num));
  }
  
  return rs;
}



export function fnum(num: number, format_dec: string): string {
  numeral.locale('es');
  return numeral(num).format(format_dec);
}



export function can_show_area(path: string): boolean {  // mantener sincronizado con la versión de NeoBook/src/utils.js (y hacer make up)
  const low = path.toLowerCase();
  
  return low.indexOf('sandra_gandolfo') === -1 && low.indexOf('cropsense') === -1;
}



export function nameConversion(app: App, name: string, isMF: boolean): string {
  if (name === 'ID'        ) { return 'Id';                  }
  if (name === 'NOMBRE'    ) { return 'Nombre';              }   // si haces un cambio aquí, no olvides cambiar y RECOMPILAR
  if (name === 'ESPECIE'   ) { return 'Especie';             }   // NeoBook/src/utils.js -> traslate_dbf_col() y viceversa.
  if (name === 'VARIEDAD'  ) { return 'Variedad';            }
  if (name === 'AREA'      ) { return 'Área';                }
  if (name === 'HECTAREAS' ) { return 'Hectáreas';           }
  if (name === 'PERIMETRO' ) { return 'Perímetro';           }
  if (name === 'PROM_MS'   ) { return 'Promedio MS (Kg/Ha)'; }
  if (name === 'COD_POTRER') { return 'Código Potrero';      }
  if (name === 'T_SIEMBRA' ) { return 'Tipo de Siembra';     }
  if (name === 'CODIGO'    ) { return 'Clave Predial';       }
  if (name === 'FUNDO'     ) { return 'Fundo';               }
  
  const conv = (
    isMF ?
      app.mf_convs.find(conv => conv.name === name)
    :
      app.normal_convs.find(conv => conv.name === name)
  );
  
  if (conv != null) {
    return conv.conversion;
  }
  else {
    return name;
  }
}



export function tipo_servicio(ms_filename: string): string {
  const tp = ms_filename.slice(0, ms_filename.indexOf('_'));
  
  if      (tp === "ms" ) { return "ADN Suelo"              ; }
  else if (tp === "mf" ) { return "ADN Foliar"             ; }
  else if (tp === "mfs") { return "ADN Físico"             ; }
  else if (tp === "mr" ) { return "Análisis de Rendimiento"; }

  return "";
};



export function show_path(path: string): string {
  const sli  = path.slice(6),
        file = takeFilename(path),
        sub  = takeExtension(file) === file ? sli : takeDir(sli);
  
  return sub.replace(/\//g, ' / ');
}



export function get_label(Path: string): string {
  return get_order({
    File: takeFilename(Path),
    Type: takeExtension(Path),
    Path
  }).label;
}



export function inv<T>(xs: Array<T>): Array<T> {
  return _.clone(xs).reverse();
}



export function no_rclick(ev: Event): void {
  if (ev.type === 'contextmenu')
    ev.preventDefault();
}



export function removable(dir: string): boolean {
  return ! takeFilename(takeDir(dir)).match(/^u_/);
}



function fix_mo(arr: Array<string>): Array<string> {
  if      (arr[1] === "m" && arr[2] === "o"  ) { arr[1] = "M.O"  ; arr.splice(2, 1); }
  else if (arr[1] === "n" && arr[2] === "min") { arr[1] = "N.min"; arr.splice(2, 1); }
  return arr;
};



export function labelize_mav(mav_filename: string): string {
  let fmav = _.cloneDeep(mav_filename);
  
  if (fmav.charAt(0) === '_') {
    fmav = fmav.slice(1);
  }
  
  const words = fix_mo(takeBasename(fmav).replace(/[_-]/gi, " ").split(" "));
  
  return _.map(words, (str, num) => {
    let word = _.cloneDeep(str);
    
    if (num === words.length - 3) {
      word = `${word.slice(3)}/${word.slice(0,3)}/wxyz`;
    }
    
    if (word && word !== 'mav') {
      return word[0].toUpperCase() + word.slice(1);
    }
    else if (word === 'mav') {
      return word.toUpperCase();
    }
    else {
      return word;
    }
  }).join(" ").replace("wxyz ", "");
};



export function is_uuid(uid: string): boolean {
  if (uid.length !== 36) { return false; }
  if (! _.chain(uid.split("-")).map((xu: string) => xu.length).isEqual([8,4,4,4,12]).value()) { return false; }
  return /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/.test(uid);
}



export function noop(result: boolean): void {}



export function node_dir(dir: string): T_Node {
  const sdir = strip_end_slash(dir);
  
  return {
    Path: sdir,
    File: takeFilename(sdir),
    Type: 'dir',
  };
}



export function get_filelist(dirs: Array<string>): Array<T_Item> {
  return _.sortBy(dirs, [dir => dir.toLowerCase()]).map(node_dir).map(get_order);
}



// FIXME: LLEVAR A T_PredOf ALGÚN DÍA:

export function fnot(fun: T_Pred): T_Pred {
  return (val => ! fun(val));
}



export function f_and<T>(fun: T_PredOf<T>, gon: T_PredOf<T>): T_PredOf<T> {
  return ((val: T): boolean => fun(val) && gon(val));
}



export function f_and3<T>(f1: T_PredOf<T>, f2: T_PredOf<T>, f3: T_PredOf<T>): T_PredOf<T> {
  return ((val: T): boolean => f1(val) && f2(val) && f3(val));
}




export function f_or<T>(fun: T_PredOf<T>, gon: T_PredOf<T>): T_PredOf<T> {
  return (val => fun(val) || gon(val));
}



export function es_mapa_tematico(path: string): boolean {
  return takeFilename(path).match(/^Mapa_Tematico_/) != null;
}



export function hs_bool(xb: boolean): string {
  return xb ? 'True' : 'False';
}



// export function des_numeral(str: string): number {
//   return parseFloat(str.replace(/\./g, '').replace(/,/g, '.'));
// }



export function flatten_nums(pairs: Array<[number, number]>): string {
  return pairs.map(ab => `${ab[0]},${ab[1]}`).join(',');
}



export function invertColor(_hex: string): string {
  let hex = _.cloneDeep(_hex);
  
  if (hex.indexOf('#') === 0) {
    hex = hex.slice(1);
  }
  
  // convert 3-digit hex to 6-digits:
  
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  
  if (hex.length !== 6) {
    return '#000000';
  }
  
  const rc = parseInt(hex.slice(0, 2), 16),
        gc = parseInt(hex.slice(2, 4), 16),
        bc = parseInt(hex.slice(4, 6), 16);
  
  return ((rc * 0.299) + (gc * 0.587) + (bc * 0.114)) > 186 ? '#000000' : '#ffffff';
}



export function fix_elem_name(elem: string): string {
  return S.words(elem, /[-_]/)
          .filter((word, num) => {
            return (! isNumber(word)) && word.indexOf('iansa') !== 0 && word.indexOf('agri') !== 0 &&
                    (! (word.indexOf('f') === 0 && num >= 1));
          })
          .join('-');
}



export function no_parens(str: string): string {
  const ss = S.strip(str);
  
  let ai = 0;
  
  if (ss[ai] === '(') {
    ai++;
  }
  
  if (ss[ss.length - 1] === ')') {
    return ss.slice(ai, -1);
  }
  else {
    return ss.slice(ai);
  }
}



export function get_url_value(param: string): string {
  if (! param) {
    return '';
  }
  
  const url   = _.cloneDeep(window.location.href),
        index = url.indexOf(param);
  
  if (index === -1) {
    return '';
  }
  else {
    const from = index + param.length + 1,
          to   = url.indexOf('&', from);
    
    return (to === -1 ? url.slice(from) : url.slice(from, to));
  }
}



// copia de _.object(), de underscore.js

export function old_object(list: Array<string>, values?: Array<any>): Object {
  const result = {};
  
  for (let ii = 0, {length} = list; ii < length; ii++) {
    if (values) {
      result[list[ii]] = values[ii];
    } else {
      result[list[ii][0]] = list[ii][1];
    }
  }
  return result;
};



export function is_pair(xs: Array<any>): boolean {
  return xs.length === 2 && (! _.isUndefined(xs[0])) && (! _.isUndefined(xs[1]));
}



export function unFuck(str: string): string {
  if (_.endsWith(str, '-f20t')) {
    return str.slice(0, str.indexOf('-f20t'));
  }
  
  const low = str.toLowerCase();
  
  if (low === 'densidadreal') {
    return 'Densidad_Real';
  }
  
  if (low === 'aguaaprovechable') {
    return 'Agua_Aprovechable';
  }
  
  if (low === 'almacenamientoagua') {
    return 'Almacenamiento_agua';
  }
  
  if (low === 'aluminio_extractable') {
    return 'Al_ext';
  }
  
  if (_.startsWith(low, 'al_sat') || _.startsWith(low, 'al sat')) {
    return 'Al_Sat';
  }
  
  if (_.startsWith(low, 'ph_cacl')) {
    return 'pH_CaCl';
  }
  
  return str;
}



export function es_curvas_nivel(path: string): boolean {
  const base = takeFilename(path).toLowerCase();
  
  return (! base.match(culti_regex)) && (base.indexOf('curva') !== -1 && base.indexOf('nivel') !== -1);
}



export function es_acuatico(path: string): boolean {
  const base = takeFilename(path).toLowerCase();
  
  return (! base.match(culti_regex)) && (
    base.indexOf('canal'  ) !== -1 || 
    base.indexOf('tranque') !== -1 || 
    base.indexOf('riego'  ) !== -1 || 
    base.indexOf('pozo'   ) !== -1
  );
}



export function es_infra(path: string): boolean {
  const base = takeFilename(path).toLowerCase();
  
  return (! base.match(culti_regex)) && (
    base.indexOf('camino' ) !== -1 || 
    base.indexOf('instala') !== -1
  );
}



export function es_landmap(path: string): boolean {
  return takeFilename(takeDir(path)).toLowerCase().indexOf('landmap') !== -1;
}



export function show_dir(dir: string): string {
  return S.titleize(dir.split('_').join(' '));
}



export function service_name(name: string): string {
  if (name === 'nutricheck_suelo' || name === 'adn_suelo') {
    return 'ADN suelo';
  }
  
  if (name === 'adn_foliar' || name === 'nutricheck_foliar') {
    return 'ADN foliar';
  }
  
  return name;
}



// devuelve el predio de un path.
// Ej: si el path es: "/MAPS/Pinsat_Peru/JUANITO/SAN_CARLOS/nutricheck_suelo/2016-07-20/cultivable_upao_2016.shp"
// devuelve:
// "/MAPS/Pinsat_Peru/JUANITO/SAN_CARLOS"   <-- sin el slash final

export function get_predio(path: string): string {
  return `/${_.take(path.split('/').filter(_.identity), 4).join('/')}`;
}



// Ej: si el path es: "/MAPS/Pinsat_Peru/JUANITO/SAN_CARLOS/nutricheck_suelo/2016-07-20/cultivable_upao_2016.shp"
// devuelve:
// "nutricheck_suelo 2016-07-20"   <-- sin el slash final, con espacios entre medio. No sirve como un subpath.

export function get_service_part(path: string): string {
  const parts = path.split('/').filter(_.identity);
  
  if (parts.length === 7) {
    return _.initial(_.drop(parts, 4)).join(' ');
  }
  else {
    return 'Desconocido';
  }
}



export function show_service(name: string): string {
  return name.split('_').map(sub => S.titleize(sub)).join(' ');
}



export function fill_with<T>(xs: Array<T>, val: T, len: number): Array<T> {
  if (xs.length >= len) {
    return xs;
  }
  else {
    while (xs.length < len) {
      xs.push(val);
    }
    
    return xs;
  }
}



export function scroll(el: ?Element | ?Text): void {
  if (el != null) {
    // $FlowFixMe
    if (el.scrollIntoViewIfNeeded && typeof el.scrollIntoViewIfNeeded === 'function') {
      el.scrollIntoViewIfNeeded();
    }
    else {
      scrollIntoViewIfNeeded(el);
    }
  }
}



export function mode<T>(arr: Array<T>): T {           // retorna el valor más repetido
  return arr.sort((va, vb) =>                         // si hay empate, retorna el valor más cercano al final.
        arr.filter(val => val === va).length
      - arr.filter(val => val === vb).length
  ).pop();
}



export function fix_range_diff(is_diff: boolean): T_NumTransformer {
  return is_diff ? (foo => foo + 100) : _.identity;
}



type T_StyleBorder = {
  border: string
};



export function border_error(is_bad: boolean): T_StyleBorder {
  return {border: `1px solid ${is_bad ? 'red' : 'lightgray'}`};
}



export function is_bio_or_photo(png_path: string): boolean {
  const low_file = takeFilename(png_path).toLowerCase();
  
  return low_file.indexOf('biosense') === 0 || low_file.indexOf('photosense') === 0 || low_file.indexOf('ndvi') === 0   ;
}



export function png_is(prefix: string, png_path: string): boolean {
  const low_file = takeFilename(png_path).toLowerCase();
  
  return low_file.indexOf(prefix) === 0;
}



export function service_is(prefix: string, dir_path: string): boolean {
  const low_dir = dir_path.toLowerCase();
  
  return low_dir.indexOf(prefix) !== -1;
}



export function add_port(url: string): string {
  if (url.indexOf(DOMAIN) !== -1)
    return url;
  
  const ds = DOMAIN.split(":");
  
  if (ds.length === 2) {
    return url.replace(ds[0], DOMAIN);
  }
  else {
    return url;
  }
}



export function fail(msg: string): false {
  console.log(msg);
  
  return false;
}



export function only_if<T>(condition: boolean, value: T): ?T {
  return condition ? value : null;
}



//// CentralFert
// Funcion para convertir profudidad a decimetros
export function conv_to_decimeters(val: number): number {
  if (val > 0 && val < 10) {
    return val
  } else {
    return val / 10
  }
}

// Funcion para saber si nitrogeno esta definido como 'n' o 'n-min'
export function is_nitrogeno(name: string): boolean {
  return name === 'n' || name.startsWith('n-min');
}

// Busca el Lyr en el png indicado, si no lo encuentra regresa ''
export function find_lyr_in(escs: Array<T_Escala>, png: string): string {
  for (const esc of escs) {
    if (esc.file === png) {
      return esc.lyrPath;
    }    
  }
  return '';
}

// Saca el valor promedio del elemento st
export function promedios(st: T_Stats): Array<number> {
  return st.rows.map(row => row.Promedio);
}

// Remueve parentesis
export function remove_parens(str: string): string {
  let res = str;

  if (_.head(res) === '(') {
    res = res.slice(1);
  }

  if (_.last(res) === ')') {
    res = res.slice(0, res.length - 1);
  }
  return res;
}

// Detecta si el rdto esta dentro del rango recomendado
export function in_range(num: number, Min: number, Max: number): boolean {
  return Min <= num && num <= Max;
}

// Funcion que permite retornar solo valores positivos, si el resultado es negativo, lo reemplaza por alt
export function positive_or(num: number, alt: number): number {
  return num >= 0 ? num : alt;
}

// Funciones para cambiar el elemento a compuesto
export const K_to_K2O = (val: number): number => val * 1.2;
export const Ca_to_CaO = (val: number): number => val * 1.399;
export const Mg_to_MgO = (val: number): number => val * 1.657;
export const P_to_P2O5 = (val: number): number => val * 2.291;
export const S_to_SO3 = (val: number): number => val * 2.5;
export const NO3_to_N = (val: number): number => val * 0.2259;

// Funciones para calcular dosis
export function dap(mo: number): number {
  if      (mo < 2             ) {return 1.4;}
  else if (mo >= 2  && mo <  6) {return 1.2;}
  else if (mo >= 6  && mo < 11) {return 1.0;}
  else if (mo >= 11 && mo < 15) {return 0.8;}
  else if (mo >= 15           ) {return 0.6;}
  
  throw new Error(`No se puede determinar el dap de materia organica = ${mo}`)
}

// Funcion para cambiar la unidad a Kg/ha
export function convert_to_kgha(val: number, prof: number, DAP: number, units: string): number {
  if      (val   === -1     ) {return -1;}
  else if (units === 'ppm' || units === ''  ) {return (val * DAP * prof);}
  else if (units === 'kg/ha') {return val;}
}

// No se que hace esta funcion... =(
export function Ntot_to_NMin(ntot: number, mo: number, dap: number): number {
  if (mo <  5 && dap >= 1) {return (ntot * 0.02);}
  if (mo <  5 && dap <  1) {return (ntot * 0.04);}
  if (mo >= 5 && dap >= 1) {return (ntot * 0.08);}
  if (mo >= 5 && dap <  1) {return (ntot * 0.12);}
}

// Funcion para calcular eficiencia nitrogeno
export function eficiencia_n(tecno: string, DAP: number): number {
  if (tecno === 'Fertirriego') {
    if      (DAP >= 1.2             ) {return 0.94;}
    else if (DAP >= 0.8 && DAP < 1.2) {return 0.96;}
    else if (DAP <  0.8             ) {return 0.98;}

  } else if (tecno === 'Aspersión') {
    if      (DAP >= 1.2             ) {return 0.92;}
    else if (DAP >= 0.8 && DAP < 1.2) {return 0.94;}
    else if (DAP <  0.8             ) {return 0.96;}

  } else if (tecno === 'Canal de riego' || tecno === 'Cobertera') {
    if      (DAP >= 1.2             ) {return 0.84;}
    else if (DAP >= 0.8 && DAP < 1.2) {return 0.86;}
    else if (DAP <  0.8             ) {return 0.88;}

  } else if (tecno === 'Incorporado') {
    if      (DAP >= 1.2             ) {return 0.90;}
    else if (DAP >= 0.8 && DAP < 1.2) {return 0.92;}
    else if (DAP <  0.8             ) {return 0.94;}

  } else {
    throw new Error(`Tecnologia de riego desconocida: ${tecno}`);
  }
}

// Funcion para calcular eficiencia fosforo
export function eficiencia_p(tecno: string, ph: number): number {
  if (tecno === 'Fertirriego' || tecno === 'Incorporado') {
    if      ( ph >= 6.5 && ph <  7.0                            ) {return 1.0; }
    else if ((ph >= 6.0 && ph <  6.5) || (ph >= 7.0 && ph < 7.5)) {return 0.98;}
    else if ( ph <  6.0 || ph >= 7.5                            ) {return 0.96;}

  } else if (tecno === 'Aspersión') {
    if      ( ph >= 6.5 && ph <  7.0                            ) {return 0.98;}
    else if ((ph >= 6.0 && ph <  6.5) || (ph >= 7.0 && ph < 7.5)) {return 0.96;}
    else if ( ph <  6.0 || ph >= 7.5                            ) {return 0.94;}

  } else if (tecno === 'Canal de riego') {
    if      ( ph >= 6.5 && ph <  7.0                            ) {return 0.9; }
    else if ((ph >= 6.0 && ph <  6.5) || (ph >= 7.0 && ph < 7.5)) {return 0.88;}
    else if ( ph <  6.0 || ph >= 7.5                            ) {return 0.86;}

  } else if (tecno === 'Cobertera') {
    if      ( ph >= 6.5 && ph <  7.0                            ) {return 0.94;}
    else if ((ph >= 6.0 && ph <  6.5) || (ph >= 7.0 && ph < 7.5)) {return 0.92;}
    else if ( ph <  6.0 || ph >= 7.5                            ) {return 0.9; }

  } else {
    throw new Error(
      `P: No pude determinar la eficiencia de la combinacion ${tecno} y ph = ${ph}`
    );
  }
}

// Funcion para calcular eficiencia potasio
export function eficiencia_k(tecno: string, DAP: number): number {
  if  (tecno === 'Fertirriego') {
    if      (DAP >= 1.2             ) {return 0.94;}
    else if (DAP >= 0.8 && DAP < 1.2) {return 0.95;}
    else if (DAP <  0.8             ) {return 0.96;}

  } else if (tecno === 'Aspersión' || tecno === 'Incorporado') {
    if      (DAP >= 1.2             ) {return 0.93;}
    else if (DAP >= 0.8 && DAP < 1.2) {return 0.94;}
    else if (DAP <  0.8             ) {return 0.95;}

  } else if (tecno === 'Canal de riego') {
    if      (DAP >= 1.2             ) {return 0.86;}
    else if (DAP >= 0.8 && DAP < 1.2) {return 0.87;}
    else if (DAP <  0.8             ) {return 0.88;}

  } else if (tecno === 'Cobertera') {
    if      (DAP >= 1.2             ) {return 0.88;}
    else if (DAP >= 0.8 && DAP < 1.2) {return 0.89;}
    else if (DAP <  0.8             ) {return 0.9; }

  } else {
    throw new Error(`Tecnologia de riego desconocida: ${tecno}`);
  }
}

// Funcion para seleccionar la demanda.
export function demRange(min, max, val) {
  if (val < min) {
    return min;
  } else if (val > max) { 
    return max;
  } else {
    return val;
  }
}
// Funcion para seleccionar el valor correcto en la dosis
export function force_in(_min: number | string, _max: number | string, val: number): number {
  if (val === -1) {
      return -1;
  }

  if (val === 0) {
      return 0;
  }

  if (_min === '' || _max === '' || _min === '0' || _max === '0') {
      return val;
  }

  const
      min: number = typeof(_min) === 'number' ? _min : parse_nullable_num(_min),
      max: number = typeof(_max) === 'number' ? _max : parse_nullable_num(_max)
  ;

  if (min < 0 || max < 0) {
      return val;
  }

  if (min >= max) {
      return val;
  }

  if (val < min) {
      return min;
  }

  if (val > max) {
      return max;
  }

  return val; 
}

// Funcion para buscar la proporcion entre demanda y suministro:
export function proporcion_dem_sum(dem: number, sum: number, efi: number): number {
  const proporcion = dem / sum;

  if (efi !== -1) {
    if (proporcion >= 0.5 && proporcion < 0.6) {
      const result = ( dem * 0.8 ) / efi;
      return result;
    } else if (proporcion < 0.5) {
      const result = ( dem * 0.6 ) / efi;
      return result;
    } else if (proporcion >= 0.6) {
      const result = dem / efi;
      return result;
    }
  } else if (efi === -1) {
    if (proporcion >= 0.5 && proporcion < 0.6) {
      const result = dem * 0.8;
      return result;
    } else if (proporcion < 0.5) {
      const result = dem * 0.6;
      return result;
    } else if (proporcion >= 0.6) {
      const result = dem;
      return result;
    }
  }
}


// Funcion para cambiar el formato de los decimales, en caso que sea necesario
export function parse_nullable_num(str: string | null): number {
  if (! str) {
      return 0;
  } else {
      return parseFloat(str.replace(',', '.'));
  }
}

// Funcion para validar RFC (México)
    
const
  _rfc_pattern_pm = "^(([A-ZÑ&]{3})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
                    "(([A-ZÑ&]{3})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
                    "(([A-ZÑ&]{3})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
                    "(([A-ZÑ&]{3})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$",

  _rfc_pattern_pf = "^(([A-ZÑ&]{4})([0-9]{2})([0][13578]|[1][02])(([0][1-9]|[12][\\d])|[3][01])([A-Z0-9]{3}))|" +
                    "(([A-ZÑ&]{4})([0-9]{2})([0][13456789]|[1][012])(([0][1-9]|[12][\\d])|[3][0])([A-Z0-9]{3}))|" +
                    "(([A-ZÑ&]{4})([02468][048]|[13579][26])[0][2]([0][1-9]|[12][\\d])([A-Z0-9]{3}))|" +
                    "(([A-ZÑ&]{4})([0-9]{2})[0][2]([0][1-9]|[1][0-9]|[2][0-8])([A-Z0-9]{3}))$"
;

export function validarRFC(rfc2) {
  let rfc = rfc2;
            
  if (rfc.match(_rfc_pattern_pm) || rfc.match(_rfc_pattern_pf)){
    return true;
  } else {
    
  return false;
  }
};



// WEBPACK FOOTER //
// ./src/utils.js